<template>
  <el-row 
    :gutter="30" 
    class="pagination">
    <ul 
      :class="[meta.perPage && `pagination-${meta.perPage}`, align && `justify-content-${align}`]" 
      class="pagination">
      <li 
        :class="{disabled: currentPage === 1}" 
        class="page-item prev-page">
        <a 
          class="page-link" 
          aria-label="Previous" 
          @click="prevPage">
          <span aria-hidden="true"><i 
            class="fa fa-angle-left" 
            aria-hidden="true"/></span>
        </a>
      </li>
      <li 
        v-for="item in range(minPage, maxPage)" 
        :class="{active: currentPage == item}"
        :key="item"
        class="page-item">
        <a 
          class="page-link" 
          @click="paginate(item)">{{ item }}</a>
      </li>
      <li 
        :class="{disabled: currentPage == meta.last}" 
        class="page-item next-page">
        <a 
          class="page-link" 
          aria-label="Next" 
          @click="nextPage">
          <span aria-hidden="true"><i 
            class="fa fa-angle-right" 
            aria-hidden="true"/></span>
        </a>
      </li>
    </ul>
  </el-row>
</template>
<script>
import { Row } from "element-ui";
export default {
  components : {
    [Row.name] : Row
  },
  props: {
    meta: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      perPageOptions: [5, 10, 15, 20, 50],
      perPage: 10,
      currentPage: 1,
      align : 'start',
      defaultPagesToDisplay: 5
    };
  },
  computed : {
       pagesToDisplay() {
      if (this.meta.last > 0 && this.meta.last < this.defaultPagesToDisplay) {
        return this.meta.last;
      }
      return this.defaultPagesToDisplay;
    },
     minPage() {
      if (this.currentPage >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.currentPage;
        if (newMaxPage > this.meta.last) {
          return this.meta.last - this.pagesToDisplay + 1;
        }
        return this.currentPage - pagesToAdd;
      } else {
        return 1;
      }
    },
    maxPage() {
      if (this.currentPage >= this.pagesToDisplay) {
        const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
        const newMaxPage = pagesToAdd + this.currentPage;
        if (newMaxPage < this.meta.last) {
          return newMaxPage;
        } else {
          return this.meta.last;
        }
      } else {
        return this.pagesToDisplay;
      }
    }
  },
  watch:{
    meta(value) {
      this.currentPage = parseInt(value.currentPage);
    }
  },
  methods: {
    setPerPage(perPage) {
      this.perPage = perPage;
      this.currentPage = 1;
      this.paginate();
    },
    paginate(page = 1) {
        this.currentPage = page;
      const data = {
          page: page,
        perPage: this.meta.perPage,
      };
      this.$emit('paginate', data);
    },
     range(min, max) {
      let arr = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },
    nextPage() {
      if (this.currentPage < this.meta.last) {
          const data = {
              page : this.currentPage + 1,
              perPage : this.meta.perPage,
          };
          this.currentPage = parseInt(data.page);
          this.$emit('paginate', data);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
          const data = {
              page : this.currentPage - 1,
              perPage  : this.meta.perPage
          }
          this.currentPage = data.page;
          this.$emit('paginate', data);
      }
    },
  }
};
</script>